var map = {
	"./barn.png": "a863",
	"./barn@2x.png": "1e78",
	"./building.png": "5c16",
	"./building@2x.png": "b12e",
	"./country.png": "e04c",
	"./country@2x.png": "872e",
	"./edificio-a.png": "9ec9",
	"./edificio-b.png": "a8e6",
	"./edificio-b@2x.png": "2451",
	"./edificio-b@3x.png": "6d8c",
	"./edificio-c.png": "7e60",
	"./edificio-c@2x.png": "3562",
	"./edificio-c@3x.png": "49c1",
	"./edificio-d.png": "99d0",
	"./edificio-d@2x.png": "ec46",
	"./edificio-d@3x.png": "7858",
	"./edificio@2x.png": "3f28",
	"./edificio@3x.png": "1877",
	"./offices.png": "7225",
	"./offices@2x.png": "582a",
	"./ph.png": "9fea",
	"./ph@2x.png": "039d",
	"./shopping.png": "f700",
	"./shopping@2x.png": "a52b",
	"./tower.png": "35a0",
	"./tower@2x.png": "73db"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8085";